import { updatePermission } from "api";
import { ActionFunction } from "react-router";

export interface PermissionsActionResponse {
  message: string;
  success: boolean;
}

const permissionsAction: ActionFunction = async ({
  request,
}): Promise<PermissionsActionResponse> => {
  const { data } = await request.json();
  let actionResponse: PermissionsActionResponse;

  try {
    const res = await updatePermission(data.permissionsArray, data.tenantID);
    if (res.ok) {
      actionResponse = {
        success: true,
        message: `Successfully updated permissions`,
      };
    } else {
      throw new Error(`Failed to update permissions`);
    }
  } catch (error) {
    const e = error as Error;
    actionResponse = {
      success: false,
      message: `Failed to update permissions: ${e.message}`,
    };
  }
  return actionResponse;
};

export default permissionsAction;
